import { z } from 'zod';

/**
 * RFC 9457 — Problem Details for HTTP APIs.
 * Egységes hibaformátum minden szervizben.
 */
export const ProblemDetailsSchema = z.object({
  type: z.string().url().or(z.literal('about:blank')),
  title: z.string(),
  status: z.number().int().min(100).max(599),
  detail: z.string().optional(),
  instance: z.string().optional(),
  // Lectura-specifikus kiegészítések
  code: z.string().optional(),
  traceId: z.string().optional(),
  errors: z
    .array(
      z.object({
        path: z.array(z.union([z.string(), z.number()])),
        message: z.string(),
        code: z.string().optional(),
      }),
    )
    .optional(),
});

export type ProblemDetails = z.infer<typeof ProblemDetailsSchema>;

export const ERROR_CODES = {
  // Autentikáció / autorizáció
  UNAUTHORIZED: 'AUTH_UNAUTHORIZED',
  FORBIDDEN: 'AUTH_FORBIDDEN',
  TOKEN_EXPIRED: 'AUTH_TOKEN_EXPIRED',
  // Validáció
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  INVALID_FORMAT: 'INVALID_FORMAT',
  // Erőforrás
  NOT_FOUND: 'RESOURCE_NOT_FOUND',
  CONFLICT: 'RESOURCE_CONFLICT',
  GONE: 'RESOURCE_GONE',
  // Üzleti
  EPUB_INVALID: 'EPUB_VALIDATION_FAILED',
  CONVERSION_FAILED: 'CONVERSION_FAILED',
  QUOTA_EXCEEDED: 'QUOTA_EXCEEDED',
  // Infra
  RATE_LIMITED: 'RATE_LIMITED',
  UPSTREAM_UNAVAILABLE: 'UPSTREAM_UNAVAILABLE',
  INTERNAL: 'INTERNAL_ERROR',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];
